import.meta.glob(['../img/**',]);

// import './scripts/select.js';
// import './helpers/tailwind_sizes.js';
import './scripts/accordion.js';
import './scripts/sliders.js';
import './scripts/animations.js';

// import './scripts/custom-video-player.js';
import './scripts/navigation.js';
// import './scripts/contact-form.js';
import './scripts/forms.js';
import './scripts/custom-video-player.js';



// import '@awesome.me/webawesome/dist/components/comparison/comparison.js';


function setScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + 1;// added + 1 so if clientWidth is with . something it will still calculate properly.
    document.documentElement.style.setProperty('--scrollbar-size', `${scrollbarWidth}px`);
}

setScrollbarWidth()


// const footerCookieYesSettingsCTA = document.querySelector('footer .cky-banner-element');
// footerCookieYesSettingsCTA.addEventListener('click',(e)=>{
//     e.preventDefault();
// })


const heroVideo = document.getElementById('hero-video');
if (heroVideo) {

    const heroVideoSource = document.getElementById('hero-video-source');

    const desktopVideoSource = heroVideo.dataset.desktopVideo;
    const mobileVideoSource = heroVideo.dataset.mobileVideo;


    function setHeroVideo() {
        console.log('here')
        const isMobile = window.innerWidth <= 768;

        const newSrc = isMobile ? mobileVideoSource : desktopVideoSource;

        // Only reload if source actually changed
        if (heroVideoSource.src !== newSrc) {
            heroVideoSource.src = newSrc;
            heroVideo.load();
        }

        // if (isMobile) {
        //     heroVideoSource.src = mobileVideoSource;
        // }else{
        //     heroVideoSource.src = desktopVideoSource;
        // }
        //
        // heroVideo.load();
    }


    setHeroVideo()
    window.addEventListener('resize', setHeroVideo)
}
